export const cardData4 = [
  {
    reviewStars: 5,
    text: "I was thoroughly satisfied with the assistance I received from Assignment In Need. They got my subject right and submitted the assignment in time. The support staff was courteous and prompt to respond. It made completing my assignment much less stressful. I would certainly use their services again.",
    avatarSrc: "assets/img/testimonial/logo/assignmentinneed.avif",
    name: "Assignment In Need",
    designation: "",
    quoteIconSrc: "assets/img/icon/quote_left.svg",
  },
  {
    reviewStars: 5,
    text: "Comfort Transfers Between made our trip easy and convenient. The driver arrived on time, courteous, and the vehicle was extremely clean. It was wonderful to enjoy such a smooth airport pick-up after a long flight. I'll be using them again next time I travel.",
    avatarSrc: "assets/img/testimonial/logo/comforttransfers.avif",
    name: "Comfort Transfers",
    designation: "",
    quoteIconSrc: "assets/img/icon/quote_left.svg",
  },
  {
    reviewStars: 5,
    text: "Let's Learn Edu made it easy for me to study. It made sense to learn in the way it presented the lessons. The instructors were easy to follow. I enjoyed that I was able to learn at my own pace. It actually made me more confident when I was studying.",
    avatarSrc: "assets/img/testimonial/logo/letslearn.avif",
    name: "Let's Learn Edu",
    designation: "",
    quoteIconSrc: "assets/img/icon/quote_left.svg",
  },
  {
    reviewStars: 5,
    text: "I adore Aloe Naturals skincare. It's very kind to my skin and smells fresh and natural. My skin has never looked or felt better since I have been using it, and it feels soft throughout the day. I'm so happy I discovered something that works and contains natural ingredients.",
    avatarSrc: "assets/img/testimonial/logo/aloe.avif",
    name: "Aloe Naturals",
    designation: "",
    quoteIconSrc: "assets/img/icon/quote_left.svg",
  },
  {
    reviewStars: 5,
    text: "Global Assignment Support was a big help with my project. The writing was good, well-researched, and completed ahead of deadline. They were a pleasure to deal with and got what I was looking for. I'd recommend them to any student who's struggling with their coursework.",
    avatarSrc: "assets/img/testimonial/logo/globalassignmentsupport.avif",
    name: "Global Assignment Support",
    designation: "",
    quoteIconSrc: "assets/img/icon/quote_left.svg",
  },
];
